import { useEffect, useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import EditNoteIcon from '@mui/icons-material/EditNote'
import DeleteIcon from '@mui/icons-material/Delete'

import { DataGridPro as DataGrid, GridToolbar } from '@mui/x-data-grid-pro'
import { LicenseInfo } from '@mui/x-license-pro'

import AppConfig from '../../config'
import PageTitle from '../../components/page-title'
import DispositionDrawer from './components/dispositionDrawer'
import DeleteDisposition from './components/deleteDisposition'

import { useGetAllDispositionsQuery } from '../../services/dispositions/slice'

LicenseInfo.setLicenseKey(AppConfig.mui.licenseKey)

const Fields = () => {
  const [showDrawer, setShowDrawer] = useState(false)
  const [currentDisposition, setCurrentDisposition] = useState(null)
  const [showDeleteDisposition, setShowDeleteDisposition] = useState(false)
  const [rows, setRows] = useState([])
  const [columns, setColumns] = useState([])

  const { data: dispositions, isLoading } = useGetAllDispositionsQuery()

  useEffect(() => {
    if (dispositions) {
      setRows(dispositions)

      const fieldColumns = [
        {
          name: 'code',
          label: 'Code',
          width: 200,
          priority: 1,
        },
        {
          name: 'label',
          label: 'Label',
          width: 200,
          priority: 2,
        },
        {
          name: 'isComplete',
          label: 'Is Complete',
          width: 100,
          priority: 3,
          type: 'boolean',
        },
        {
          name: 'isSuccess',
          label: 'Is Successful',
          width: 100,
          priority: 4,
          type: 'boolean',
        },
      ]

      const cols = fieldColumns
        .map((fieldColumn) => {
          return {
            field: fieldColumn.name,
            headerName: fieldColumn.label,
            width: fieldColumn.width || 200,
            description: fieldColumn.description || fieldColumn.label,
            priority: fieldColumn.priority || 1000,
            type: fieldColumn.type === 'boolean' ? 'boolean' : undefined,
          }
        })
        .sort((a, b) => a.priority - b.priority)

      setColumns([
        ...cols,
        {
          field: 'actions',
          headerName: 'Action',
          width: 80,
          sortable: false,
          disableClickEventBubbling: true,

          renderCell: (params) => {
            const onEditClick = (disposition) => {
              setCurrentDisposition(disposition)
              setShowDrawer(true)
            }
            const onDeleteClick = (disposition) => {
              setCurrentDisposition(disposition)
              setShowDeleteDisposition(true)
            }

            return (
              <>
                <Stack direction="row">
                  <IconButton size="small" onClick={() => onEditClick(params?.row)}>
                    <EditNoteIcon />
                  </IconButton>
                  <IconButton size="small" onClick={() => onDeleteClick(params?.row)}>
                    <DeleteIcon />
                  </IconButton>
                </Stack>
              </>
            )
          },
        },
      ])
    }
  }, [dispositions])

  const onAddClick = () => {
    setCurrentDisposition(null)
    setShowDrawer(true)
  }

  const action = (
    <Button variant="outlined" onClick={onAddClick} startIcon={<AddCircleOutlineIcon />}>
      Add
    </Button>
  )

  return (
    <>
      <PageTitle title="Dispositions" action={action} />
      <Box>
        <DataGrid
          rows={rows}
          columns={columns}
          density="compact"
          pagination
          loading={isLoading}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          slots={{
            toolbar: GridToolbar,
          }}
          pageSizeOptions={[25, 50, 100]}
          disableRowSelectionOnClick
          sx={{
            '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
              outline: 'none !important',
            },
            '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus': {
              outline: 'none !important',
            },
          }}
        />
      </Box>
      <DispositionDrawer
        currentDisposition={currentDisposition}
        showDrawer={showDrawer}
        setShowDrawer={setShowDrawer}
      />
      <DeleteDisposition
        disposition={currentDisposition}
        open={showDeleteDisposition}
        setOpen={setShowDeleteDisposition}
      />
    </>
  )
}

export default Fields
